import React from "react";
import { Container, Grid, Card, CardMedia, Typography, Box } from "@mui/material";

const photos = [
  { id: 1, src: "https://example.com/photo1.jpg", title: "Event 1" },
  { id: 2, src: "https://example.com/photo2.jpg", title: "Event 2" },
  { id: 3, src: "https://example.com/photo3.jpg", title: "Event 3" },
  { id: 4, src: "https://example.com/photo4.jpg", title: "Event 4" },
  // Add more photos
];

export default function Photogallery() {
  return (
    <Container sx={{ marginTop: 4 }}>
      <Typography variant="h4" gutterBottom align="center">
        Фотогалерея
      </Typography>
      <Grid container spacing={4}>
        {photos.map((photo) => (
          <Grid item xs={12} sm={6} md={4} key={photo.id}>
            <Card>
              <CardMedia
                component="img"
                height="200"
                image={photo.src}
                alt={photo.title}
              />
              <Box sx={{ p: 2 }}>
                <Typography variant="h6">{photo.title}</Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
